@import './app.css';

@layer base {
  a {
    @apply tw:text-inherit;
  }
}
